import { ajax } from '@/api/ajax';

export type TQueryFileInfoParams = {
  splicingFileIds: string;
  /**0否 1 是 */
  useFileTime?: number;
  /**0否 1 是 */
  waterMark?: number;
  waterMarkText?: string;
};

export type QueryFileInfoRes = FileInfo[];
export type FileInfo = {
  filePath: string;
  fileName: string;
  fileType: string;
  size: number;
  fileId: string;
};

// 根据fileId获取附件信息
export function queryFileInfoApi(p: TQueryFileInfoParams) {
  return ajax<QueryFileInfoRes>({
    url: '/api/tis/web/epc/common/eapSysAttachment/listByFileIds',
    method: 'post',
    data: p
  });
}
